import { render, staticRenderFns } from "./NotePopup.vue?vue&type=template&id=f0ae286c&scoped=true&"
import script from "./NotePopup.vue?vue&type=script&lang=ts&"
export * from "./NotePopup.vue?vue&type=script&lang=ts&"
import style0 from "./NotePopup.vue?vue&type=style&index=0&id=f0ae286c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ae286c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
